<template>
  <div id="map-section" class="home-map-section" v-if="!isLoading">
    <ShipSection
      :ships="assets"
      @toggle-trail="handleTrailToggle"
      @trail-range="handleTrailRange"
      @zoom-to-ship="zoomToShip"
      @toggle-visibility="handleVisibilityToggle"
      @show-all-ships="handleShowAll"
      @hide-all-ships="handleHideAll"
      @set-base-layer="handleSetBaseLayer"
      @set-icon-style="handleSetIconStyle"
      @set-icon-scale="handleSetIconScale"
      @toggle-landmarks="handleToggleLandmarks"
      @toggle-timezones="handleToggleTimezones"
      @toggle-collapse="handleSidebarCollapse"
    />
    <div class="home-map-wrapper">
      <WindyMap ref="windyMap" :key="isWeatherMode" :ships="assets" :sidebarVisible="sidebarVisible" />
    </div>
  </div>
  <div class="text-center text-danger my-2" v-else>
    <b-spinner class="align-middle"></b-spinner>
    <strong>Loading...</strong>
  </div>
</template>

<script>
import WindyMap from '@/views/home/components/WindyMap';
import ShipSection from '@/views/home/components/ShipSection';
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    WindyMap,
    ShipSection,
  },
  data() {
    return {
      isLoading: true,
      isWeatherMode: false,
      sidebarVisible: true,
    };
  },
  computed: {
    ...mapState('asset', {
      assets: (state) => state.assets.filter((asset) => asset.lastGpsData),
    }),
  },
  methods: {
    async toggleWeatherMode() {
      this.isLoading = true;
      setTimeout(() => {
        this.isWeatherMode = !this.isWeatherMode;
        this.isLoading = false;
      }, 300);
    },
    async fetchData() {
      await this.$store.dispatch('asset/fetchAndReconcileAssets');
    },
    zoomToShip(ship) {
      if (this.$refs.windyMap) this.$refs.windyMap.panToShip(ship);
    },
    handleTrailToggle(payload) {
      if (this.$refs.windyMap) this.$refs.windyMap.setTrailForShip(payload);
    },
    handleTrailRange() {
      // ponytail: trail range needs coordinate refetch by day-window in the store - escalate when needed
    },
    handleVisibilityToggle(payload) {
      this.$store.dispatch('asset/updateAssetVisibility', payload);
      if (this.$refs.windyMap) this.$refs.windyMap.setShipVisibility(payload.massId, payload.isVisible);
    },
    handleShowAll() {
      this.$store.dispatch('asset/setAllAssetsVisibility', true);
      if (this.$refs.windyMap) this.$refs.windyMap.setAllShipsVisibility(true);
    },
    handleHideAll() {
      this.$store.dispatch('asset/setAllAssetsVisibility', false);
      if (this.$refs.windyMap) this.$refs.windyMap.setAllShipsVisibility(false);
    },
    handleSetBaseLayer() {
      // ponytail: base layer not wired in WindyMap
    },
    handleSetIconStyle() {
      // ponytail: icon style not wired in WindyMap
    },
    handleSetIconScale() {
      // ponytail: icon scale not wired in WindyMap
    },
    handleToggleLandmarks() {
      // ponytail: landmarks not wired in WindyMap
    },
    handleToggleTimezones() {
      // ponytail: timezones not wired in WindyMap
    },
    handleSidebarCollapse(isCollapsed) {
      this.sidebarVisible = !isCollapsed;
    },
  },
  async mounted() {
    try {
      await this.fetchData();
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped>
.home-map-section {
  position: relative;
  display: flex;
  height: calc(100vh - 70px);
  width: 100%;
  overflow: hidden;
}

.home-map-wrapper {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
}
</style>
